import { ReactElement } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRedirect, useQueryParams, useCheckout } from 'services/hooks';
import { locations } from 'services/routes/locations';
import { RegistrationForm } from './components';

interface LocationState {
  from?: Location;
}

const Register = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getQueryParams } = useQueryParams();
  const queryParams = getQueryParams(location.search);

  const { from } = location?.state ?? ({} as LocationState);

  const { getRedirectionPath } = useRedirect();
  const { createCheckoutSession } = useCheckout();

  const handleRedirection = () => {
    const { priceId, isFree } = queryParams;

    if (isFree) {
      navigate(locations.general.songList.pathname);
      return;
    }

    if (typeof priceId === 'string') {
      createCheckoutSession(priceId);
      return;
    }

    if (from) {
      navigate(from.pathname);
      return;
    }

    const path = getRedirectionPath();
    navigate(path);
  };

  const onSuccess = () => {
    handleRedirection();
  };

  return (
    <Box>
      <RegistrationForm onSuccess={onSuccess} />
    </Box>
  );
};

export default Register;
